<template>
  <domain-info :domainid="domainid"/>
</template>

<script>
import DomainInfo from '@/components/Domains/DomainInfo'

export default {
  name: 'DomainInfoView',
  components: {
    DomainInfo
  },
  props: {
    domainid: {
      type: [String, Number],
      required: true,
    }
  },

}
</script>
